module.exports = __webpack_public_path__ + "static/media/2.a9d9e9be.jpg";